export const pageID = {
    pageInfo: {
        pageName: "",
        pageType: "",
        pageTitle: "",
        brand: "",
        pageUniqueID: "no-id",
        platform: "",
    },
    category: {
        subCategory: "",
        subCategory1: "",
        subCategory2: "",
    },
    environment: {
        app_type: "",
        language: "",
        timestamp: "",
        version: "",
    },
};
const profileID = {
    loginStatus: "",
    userID: "",
    userType: "",
    accountStatus: "",
};
const freeSearch = {
    searchTerm: "",
    searchResultsCount: "",
    internalSearchType: "",
    eventSearchRequery: "",
};
const suggestionSearch = {
    searchTerm: "",
    searchTermContextual: "",
    searchResultsCount: "",
    internalSearchType: "",
};
const nullSearch = {
    searchTerm: "",
    noResultsSearchTerm: "",
    internalSearchType: "",
};
const categeoryPage = {
    name: "",
    linkposition: "",
    linktext: "",
    linktitle: "",
    locationurl: "",
    targeturl: "",
};
const socialShare = {
    name: "",
    platformName: "",
    targetURL: "",
    smActionType: "",
    loginStatus: "",
    userID: "",
    userType: "",
    accountStatus: "",
};
const linkToApp = {
    name: "",
    platformName: "",
    smActionType: "",
    loginStatus: "",
    userID: "",
    userType: "",
    accountStatus: "",
};
const favoritesOrWatchList = {
    name: "",
    linktitle: "",
    locationurl: "",
    targeturl: "",
};
const errorPageEvent = {
    errorPages: "",
};
const loginEvent = {
    name: "",
    linkposition: "",
    linktext: "",
    locationurl: "",
    targeturl: "",
    platformName: "",
};
const subscribeEvent = {
    shoppingProducts: "",
    subscriptionID: "",
    subscriptionplan: "",
    loginStatus: "",
    userID: "",
    userType: "",
    accountStatus: "",
};
const adImpression = {
    ad_id: "",
    ad_name: "",
    ad_length: 0,
    ad_position: "",
    ad_contentType: "",
};
const buyNow = {
    name: "",
    parentTitle: "",
    parentPosition: 0,
    childTitle: "",
    childPosition: 1,
    targetUrl: "",
};
export var AdobeEvents;
(function (AdobeEvents) {
    AdobeEvents["PAGE_LOADED"] = "page loaded";
    AdobeEvents["FREE_SEARCH_EVENT"] = "free search";
    AdobeEvents["MODULE_LINK_TRACK"] = "module link tracking";
    AdobeEvents["SOCIAL_FOLLOW_US"] = "social follow";
    AdobeEvents["SUGGESTION_SEARCH_EVENT"] = "suggestion search";
    AdobeEvents["ERROR_TRACKING"] = "error tracking";
    AdobeEvents["SUBSCRIBE_PRICE_PLAN"] = "subscribe";
    AdobeEvents["AD_IMPRESSION"] = "ad_impression";
    AdobeEvents["BUY_NOW"] = "buy now";
})(AdobeEvents || (AdobeEvents = {}));

